/**
 * The schematic federal grid: 5 columns x 10 rows, north to south, west to
 * east. Deliberately not a topographic SVG — the negative space draws an
 * approximation of Argentina's silhouette while keeping every jurisdiction
 * equally legible. The layout is brand identity (visual-identity.md), so it
 * ships here as the default geometry; consumers key their data by
 * jurisdiction id and borrow code + position from this table.
 */

import type { MapGridPosition } from './types';

export const MAP_GRID_COLS = 5;
export const MAP_GRID_ROWS = 10;

export interface MapGridSlot {
  readonly code: string;
  readonly gridPosition: MapGridPosition;
}

/** Cell code and position for the 24 jurisdictions, keyed by catalog id. */
export const DEFAULT_GRID: Readonly<Record<string, MapGridSlot>> = {
  // CABA + Centro
  caba: { code: 'CABA', gridPosition: { row: 4, col: 4 } },
  'buenos-aires': { code: 'BSAS', gridPosition: { row: 5, col: 3 } },
  cordoba: { code: 'CBA', gridPosition: { row: 4, col: 2 } },
  'santa-fe': { code: 'SFE', gridPosition: { row: 3, col: 3 } },
  'entre-rios': { code: 'ERI', gridPosition: { row: 3, col: 4 } },
  'la-pampa': { code: 'LPA', gridPosition: { row: 5, col: 2 } },
  // NOA
  jujuy: { code: 'JUJ', gridPosition: { row: 0, col: 1 } },
  salta: { code: 'SAL', gridPosition: { row: 1, col: 1 } },
  tucuman: { code: 'TUC', gridPosition: { row: 2, col: 1 } },
  catamarca: { code: 'CAT', gridPosition: { row: 2, col: 0 } },
  'la-rioja': { code: 'LRJ', gridPosition: { row: 3, col: 0 } },
  'santiago-del-estero': { code: 'SGO', gridPosition: { row: 3, col: 2 } },
  // NEA
  formosa: { code: 'FOR', gridPosition: { row: 1, col: 3 } },
  chaco: { code: 'CHA', gridPosition: { row: 2, col: 3 } },
  corrientes: { code: 'COR', gridPosition: { row: 2, col: 4 } },
  misiones: { code: 'MIS', gridPosition: { row: 1, col: 4 } },
  // Cuyo
  mendoza: { code: 'MZA', gridPosition: { row: 5, col: 0 } },
  'san-juan': { code: 'SJU', gridPosition: { row: 4, col: 0 } },
  'san-luis': { code: 'SLU', gridPosition: { row: 5, col: 1 } },
  // Patagonia
  neuquen: { code: 'NEU', gridPosition: { row: 6, col: 0 } },
  'rio-negro': { code: 'RNE', gridPosition: { row: 6, col: 1 } },
  chubut: { code: 'CHU', gridPosition: { row: 7, col: 1 } },
  'santa-cruz': { code: 'SCR', gridPosition: { row: 8, col: 1 } },
  'tierra-del-fuego': { code: 'TDF', gridPosition: { row: 9, col: 2 } },
};
